/** Suggest a display name for a duplicated enterprise. */
export function suggestDuplicateEnterpriseName(sourceName: string): string {
  const trimmed = sourceName.trim();
  if (!trimmed) return "Copy";
  if (/\s2$/i.test(trimmed)) {
    return `${trimmed} copy`;
  }
  return `${trimmed} 2`;
}

/** kebab-case slug aligned with christo `makeSlug` / schema rules. */
export function enterpriseNameToSlug(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-+/g, "-");
}

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export async function pollUntilSettled<T extends { status: string }>(
  fetchStatus: () => Promise<T>,
  options?: { intervalMs?: number; timeoutMs?: number },
): Promise<T> {
  const intervalMs = options?.intervalMs ?? 5000;
  const timeoutMs = options?.timeoutMs ?? 45 * 60 * 1000;
  const started = Date.now();

  while (Date.now() - started < timeoutMs) {
    const result = await fetchStatus();
    if (result.status === "succeeded") {
      return result;
    }
    if (result.status === "failed") {
      throw new Error("Duplicate job failed");
    }
    await sleep(intervalMs);
  }

  throw new Error("Duplicate timed out");
}
